module.exports = __webpack_public_path__ + "img/kx4.c0bc4b16.png";